/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react'
import { Helmet } from 'react-helmet'
import Modal from 'react-modal'
import styled from 'styled-components'
import useMedia from 'use-media'

// Images
import X from 'img/x.inline.svg'

const XWrapper = styled.button`
  top: 0;
  right: 0;
  transition: all 0.25s ease;

  &:hover {
    opacity: 0.75;
  }
`

interface ModalVideoProps {
  isOpen: boolean
  onRequestClose: any
  fields: any
}

const ModalVideo: React.FC<ModalVideoProps> = ({
  isOpen,
  onRequestClose,
  fields
}) => {
  const isDesktop = useMedia({ minWidth: 992 })

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      width: isDesktop ? '90%' : '100%',
      height: 'fit-content',
      right: 'auto',
      border: 0,
      bottom: 'auto',
      marginRight: '-50%',
      maxWidth: '100%',
      backgroundColor: 'transparent',
      transform: 'translate(-50%, -41%)',
    },
    overlay: {
      backgroundColor: 'rgb(5, 26, 64, 0.7)',
    },
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} style={customStyles}>
      <div
        className="position-relative d-flex flex-column align-items-end"
        style={{ overflow: 'scroll' }}
      >
        <XWrapper onClick={onRequestClose}>
          <X />
        </XWrapper>
        <video width="100%" height="100%" controls>
          <source src={fields?.video} type="video/mp4" />
        </video>
      </div>
    </Modal>
  )
}

export default ModalVideo
